import VaporPage from "@vapor/react-custom/VaporPage";
import { ProxyUrlRequest } from "./use-request/ProxyUrlRequest";
import { FullUrlRequest } from "./use-request/FullUrlRequest";
import { MockRequest } from "./use-request/MockRequest";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const ExampleList = ({ exampleUrl }) => {
  return (
    <VaporPage title={`@onefront/react-sdk examples`}>
      <VaporPage.Section withDivider>
        <ProxyUrlRequest />
        <FullUrlRequest exampleUrl={exampleUrl} />
        <MockRequest />
      </VaporPage.Section>
      <VaporPage.Section>
        <ExtendedTypography variant="titleSmall">
          Add here other examples
        </ExtendedTypography>
      </VaporPage.Section>
    </VaporPage>
  );
};
